import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { API_URL } from "../../config";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import Loader from "../Loader/Loader";
import Home from "../Player/Home";
import Test from "../Player/Test";
import VerifiedPlayer from "../Player/VerifiedPlayer";
import BankDetails from "../Player/BankDetails";
import Notification from "../Player/Notification";
import Ticket from "../Player/Ticket";
import RefferalList from "../Player/RefferalList";
import History from "../Player/HistoryList";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import EmptyState from "../../Components/EmptyState";

const filterSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
    padding: "2px 8px",
    fontSize: "0.95rem",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? "#ffc107" 
      : state.isFocused 
      ? "rgba(255, 193, 7, 0.1)" 
      : "#fff",
    color: state.isSelected ? "#000" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#ffc107",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PlayerList() {
  const { showPage, setShowPage, accessObject, addNewPlayer, setAddNewPlayer } =
    useAppContext();
  const { socket } = useAppContext();

  
  const [alert, setAlert] = React.useState(null);
  const [rowValue, setRowValue] = React.useState();
  const [value, setValue] = React.useState(0);
  // const [tableData, setTableData] = React.useState([]);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(true);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [filteredData, setFilteredData] = React.useState([]);
  const [historyData, setHistoryData] = React.useState([]);
  const [changeStatus, setChangeStatus] = React.useState();
  const [changeDeviceType, setChangeDeviceType] = React.useState();
  const [searchEmail, setSearchEmail] = React.useState();
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState(1);
  const [testPage, setTestPage] = React.useState(false);
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [loginType, setLoginType] = React.useState(-1);
  const [deviceType, setDeviceType] = React.useState(-1);
  const [playerStatus, setPlayerStatus] = React.useState(-1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  React.useEffect(() => {
    getPlayerList();
  }, [
    pageNumber,
    recordLength,
    searchEmail,
    testPage,
    startDate,
    endDate,
    loginType,
    playerStatus,
    deviceType,
  ]);

  const getPlayerList = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/player/get-all-player-details`, {
        pageNumber: pageNumber,
        recordLength: recordLength,
        deviceType: parseInt(deviceType),
        search: searchEmail,
        kycStatus: parseInt(changeStatus),
        startDate: startDate,
        endDate: endDate,
        loginType: parseInt(loginType),
        playerStatus: parseInt(playerStatus),
      })
      .then((response) => {
        setLoader(false);
        setFilteredData(response.data.data.playerData);
        setTotalLength(response.data.data?.totalLength);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const warningWithConfirmMessage = (e) => {
    console.log("warningWithConfirmMessage ---", e);
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title="Are you sure?"
        onConfirm={() => {
          deleteData(e);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      ></SweetAlert>
    );
  };

  const errorMessageDialog = (message) => {
    setAlert(
      <SweetAlert
        error
        style={{ display: "block" }}
        title={message}
        onConfirm={() => {
          setAlert(null);
          setButtonLoader(false);
        }}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="danger"
      ></SweetAlert>
    );
  };

  const successDeleted = () => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Deleted!"
        onConfirm={() => {
          getPlayerList();
          setAlert(null);
        }}
        confirmBtnBsStyle="success"
      >
        Your Player Record has been deleted
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);
    axios
      .get(`${API_URL}/api/admin/player/delete-player/${e._id}`)
      .then((res) => {
        console.log(res);
        console.log("res :::", res);
        const data = {
          playerId: e.playerId,
        };
        if (res.data.status) {
          successDeleted();
          socket.emit("PlayerDetailsDelete", data);
        }
        console.log(res.data);
      });
  };

  const successEdit = (message) => {
    console.log("successEdit ---", message);
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={message}
        onConfirm={() => {
          getPlayerList();
          setAlert(null);
        }}
        confirmBtnBsStyle="success"
      >
        `{message ? message : "Your Player Record has been Edited"}`
      </SweetAlert>
    );
  };

  const clickEditButton = async (item) => {
    setShowPage(true);
    setValue(0);
    console.log("item edit value :::", item);

    const getPlayerData = await axios.get(
      `${API_URL}/api/admin/player/get-single-player-details/${item._id}`
    );
    console.log("getPlayerData...", getPlayerData.data.data);
    setRowValue(getPlayerData.data.data.playerData);
    setHistoryData(getPlayerData.data.data.playerData.playerId);
  };

  const LoginSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().required("email required"),
    password: Yup.string().required("password is required"),
  });

  const successAdd = (message) => {
    console.log("successAdd ---", message);
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Added successfully!"
        onConfirm={() => {
          getPlayerList();
          setAlert(null);
          setAddNewPlayer(false);
          setButtonLoader(false);
        }}
        confirmBtnBsStyle="success"
      >
        `{message ? message : "Your Player Record has been Added ..."}`
      </SweetAlert>
    );
  };

  const exportPlayerData = async () => {
    try {
      setLoader(true);
      const response = await axios.post(
        `${API_URL}/api/admin/report/download-player`,
        {
          startDate: startDate,
          endDate: endDate,
          loginType: parseInt(loginType),
          deviceType: parseInt(deviceType),
          playerStatus: parseInt(playerStatus),
          search: searchEmail,
        },
        {
          responseType: "blob",
        }
      );

      // Check if we got a valid response
      if (!response.data || response.data.size === 0) {
        throw new Error("Empty response from server");
      }

      // Determine file type from content type or URL
      const contentType = response.headers["content-type"];
      const fileExtension = contentType.includes("excel")
        ? "xlsx"
        : contentType.includes("csv")
        ? "csv"
        : "xlsx"; // default to xlsx

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `players_${moment().format("YYYY-MM-DD")}.${fileExtension}`
      );
      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.remove();
      }, 100);
    } catch (error) {
      console.error("Export error:", error.response || error);
      errorMessageDialog(
        error.response?.data?.message || "Failed to export player data"
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {alert}
      <div className="content p-3">
        <div className="card">
          <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
            <div className="row align-items-end justify-content-start">
              <div className="col-md-2 mb-3">
                <label className="small text-muted font-weight-bold mb-1">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", padding: "8px 12px", fontSize: "0.95rem" }}
                  value={startDate}
                  onChange={(e) => {
                    setPageNumber(1);
                    setStartDate(e.target.value);
                  }}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="small text-muted font-weight-bold mb-1">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  style={{ borderRadius: "10px", border: "1.5px solid #e2e8f0", padding: "8px 12px", fontSize: "0.95rem" }}
                  value={endDate}
                  onChange={(e) => {
                    setPageNumber(1);
                    setEndDate(e.target.value);
                  }}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="small text-muted font-weight-bold mb-1">Login Type</label>
                <Select
                  styles={filterSelectStyles}
                  options={[
                    { value: -1, label: "All" },
                    { value: 0, label: "Guest" },
                    { value: 1, label: "Phone" },
                    { value: 2, label: "Email" },
                    { value: 3, label: "Google" },
                    { value: 4, label: "Facebook" },
                    { value: 5, label: "Apple" },
                  ]}
                  value={
                    [
                      { value: -1, label: "All" },
                      { value: 0, label: "Guest" },
                      { value: 1, label: "Phone" },
                      { value: 2, label: "Email" },
                      { value: 3, label: "Google" },
                      { value: 4, label: "Facebook" },
                      { value: 5, label: "Apple" },
                    ].find(o => o.value == loginType) || { value: -1, label: "All" }
                  }
                  onChange={(option) => {
                    setPageNumber(1);
                    setLoginType(option.value);
                  }}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="small text-muted font-weight-bold mb-1">Player Status</label>
                <Select
                  styles={filterSelectStyles}
                  options={[
                    { value: -1, label: "All" },
                    { value: 0, label: "Active" },
                    { value: 1, label: "Banned" },
                    { value: 2, label: "Deleted" },
                  ]}
                  value={
                    [
                      { value: -1, label: "All" },
                      { value: 0, label: "Active" },
                      { value: 1, label: "Banned" },
                      { value: 2, label: "Deleted" },
                    ].find(o => o.value == playerStatus) || { value: -1, label: "All" }
                  }
                  onChange={(option) => {
                    setPageNumber(1);
                    setPlayerStatus(option.value);
                  }}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="small text-muted font-weight-bold mb-1">Device Type</label>
                <Select
                  styles={filterSelectStyles}
                  options={[
                    { value: -1, label: "All" },
                    { value: 0, label: "Android" },
                    { value: 1, label: "IOS" },
                  ]}
                  value={
                    [
                      { value: -1, label: "All" },
                      { value: 0, label: "Android" },
                      { value: 1, label: "IOS" },
                    ].find(o => o.value == deviceType) || { value: -1, label: "All" }
                  }
                  onChange={(option) => {
                    setPageNumber(1);
                    setDeviceType(option.value);
                  }}
                />
              </div>
              <div className="col-md-2 mb-3 d-flex align-items-end">
                <button
                  className="btn btn-success w-100 font-weight-bold"
                  onClick={() => exportPlayerData()}
                  disabled={loader || filteredData.length === 0}
                  style={{ height: "42px", borderRadius: "10px", border: "none" }}
                >
                  <i className="fas fa-file-excel mr-2"></i>
                  Download
                </button>
              </div>
            </div>
          </div>
          <div class="card-body" style={{ overflow: "scroll" }}>
            <table id="" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>SrNo</th>
                  <th style={{ textAlign: "center" }}>Date</th>
                  <th style={{ textAlign: "center" }}>Id</th>
                  <th style={{ textAlign: "center" }}>Name</th>
                  <th style={{ textAlign: "center" }}>Email</th>
                  <th style={{ textAlign: "center" }}>Balance</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                  <th style={{ textAlign: "center" }}>KYC Status</th>
                  <th style={{ textAlign: "center" }}>Device Type</th>

                </tr>
              </thead>
              {accessObject?.getPlayerList === true ? (
                <>
                  <tbody>
                    {!loader ? (
                      <>
                        {filteredData.length > 0 ? (
                          <>
                            {filteredData?.map((item, index) => {
                              return (
                                <>
                                  <tr key={index}>
                                    <td>
                                      {pageNumber === 1
                                        ? index + 1
                                        : index +
                                          1 +
                                          pageNumber * recordLength -
                                          recordLength}
                                    </td>
                                    <td>
                                      {moment(item.createdAt).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </td>
                                    <td>{item.playerId}</td>
                                    <td>{item.name || "-"}</td>
                                    <td>{item.email || "-"}</td>
                                    <td>
                                      {item.depositeBalance +
                                        item.withdrawBalance +
                                        item.bonusBalance}
                                      {/* {Math.round(item.balance * 100) /
                                              100} */}
                                    </td>
                                    <td>
                                      {item.playerStatus === 0
                                        ? "Active"
                                        : "Banned"}
                                    </td>
                                    <td>
                                      {item.kycStatus === 0
                                        ? "Pending"
                                        : item.kycStatus === 1
                                        ? "Verified"
                                        : item.kycStatus === 2
                                        ? "Not Verified"
                                        : "-"}
                                    </td>
                                    <td>
                                      {item.deviceType === 0
                                        ? "Android"
                                        : item.deviceType === 1
                                        ? "IOS"
                                        : "-"}
                                    </td>

                                  </tr>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <EmptyState colSpan={9} message="No Data Found" subMessage="We couldn't find any player records matching your criteria." />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </>
              ) : (
                <>
                  <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <td colSpan={9}>
                      <h5 className="text-center">Access Denied</h5>
                    </td>
                  </tr>
                </>
              )}
            </table>
            {accessObject?.getPlayerList == true && (
              <div className="mt-4">{loader && <Loader />}</div>
            )}
          </div>
          {accessObject?.getPlayerList == true && filteredData.length != 0 && (
            <div>
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={filteredData.length}
                paginationTypeApi={true}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                recordLength={recordLength}
                setRecordLength={setRecordLength}
                totalLength={totalLength}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
